<template>
  <div class="UNinfo-main-container">
    <div class="first-info-container">
      <img class="first-img" :src="firstImgUrl">
      <div class="first-txt-container">
        <div class="first-txt-title">{{firstInfo.title}}</div>
        <div class="first-txt-time">{{firstInfo.createTime}}</div>
        <div class="first-txt-desc">{{firstInfo.subtitle}}</div>
        <div class="know-more-btn" @click="clickInfo">
          <div style="font-size:0.28rem;cursor: pointer">
            了解更多
          </div>
        </div>
      </div>
    </div>
    <div
      class="UN-other-container"
      v-for="(item,index) in xinwenInfos"
      :key="index"
      :data-id="index"
      @click="clickInfo"
    >
      <img class="UN-info-img" :src="item.tradeNewsImgList[0].url">
      <div class="UN-other-txt-container">
        <div class="UN-txt-title first-txt-title">{{item.title}}</div>
        <div class="UN-txt-time first-txt-time">{{item.createTime}}</div>
        <div class="UN-txt-desc first-txt-desc" style="margin-top:0.36rem">{{item.subtitle}}</div>
      </div>
    </div>
    <pager :total="page" @transfer="setInfos" :type=2></pager>
  </div>
</template>

<script>
import UtilPaths from '../../utils/UtilsPath'
import axios from 'axios'
import pager from '../Pager'
export default {
  data () {
    return {
      firstInfo: {},
      firstImgUrl: '',
      xinwenInfos: [],
      page: 0,
      currentPage: 1
    }
  },
  async mounted () {
    let tempIndex = parseInt(this.$route.params.index) + 1
    if (tempIndex) {
      tempIndex = JSON.stringify(tempIndex)
      sessionStorage.setItem('UNInfoIndex', tempIndex)
    } else {
      tempIndex = sessionStorage.getItem('UNInfoIndex')
    }
    sessionStorage.setItem('UNIndex', 0)
    let Infos = await axios.get(UtilPaths.getUNInfo + '/' + tempIndex + '/' + 4)
    let tempInfos = Infos.data
    if (tempInfos.records.length !== 1) {
      let tempOtherInfos = []
      this.$data.firstInfo = tempInfos.records[0]
      this.$data.firstImgUrl = tempInfos.records[0].tradeNewsImgList[0].url
      this.$data.page = tempInfos.pages
      this.$data.currentPage = tempInfos.current
      for (let i = 1; i < tempInfos.records.length; i++) {
        tempOtherInfos[i - 1] = tempInfos.records[i]
      }
      this.$data.xinwenInfos = tempOtherInfos
    } else {
      this.$data.firstInfo = tempInfos.records[0]
      this.$data.firstImgUrl = tempInfos.records[0].tradeNewsImgList[0].url
      this.$data.page = tempInfos.pages
      this.$data.currentPage = tempInfos.current
    }
  },
  methods: {
    clickInfo (e) {
      if (e.srcElement.innerText === '了解更多') {
        this.$router.push({ name: 'UNMoreInfo', params: { index: 0, currentpage: this.$data.currentPage, info: this.$data.firstInfo } })
      } else {
        let temp = parseInt(e.currentTarget.dataset.id)
        this.$router.push({ name: 'UNMoreInfo', params: { index: temp + 1, currentpage: this.$data.currentPage, info: this.$data.xinwenInfos[temp] } })
      }
    },
    setInfos (item) {
      if (item.length === 1) {
        this.$data.firstInfo = item[0]
        this.$data.xinwenInfos = []
      } else {
        let tempOtherInfos = []
        for (let i = 1; i < item.length; i++) {
          tempOtherInfos[i - 1] = item[i]
        }
        this.$data.firstInfo = item[0]
        this.$data.xinwenInfos = tempOtherInfos
      }
    }
  },
  components: {
    pager
  }
}
</script>

<style scoped>
.UNinfo-main-container{
  display: flex;
  margin-top: 2.14rem;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.first-info-container{
  display: flex;
  padding-bottom: 2.14rem;
  border-bottom: 1px #333333 dashed;
}
.first-img{
  width: 16.25rem;
  height: 9.57rem;
}
.first-txt-container{
  display: flex;
  flex-direction: column;
  margin-left: 1.78rem;
  text-align: start;
  position: relative;
  width: 23rem;
}
.first-txt-title{
  font-size: 0.85rem;
  color: #333333;
  letter-spacing: 3.5px;
}
.first-txt-time{
  font-size: 0.5rem;
  color: #999999;
  letter-spacing: 3px;
}
.first-txt-desc{
  font-size: 0.64rem;
  color: #999999;
  letter-spacing: 3.5px;
  margin-top: 0.46rem;
}
.know-more-btn{
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px #333333 solid;
  width: 3.57rem;
  height: 1.07rem;
  position: absolute;
  bottom: 0;
}
.UN-other-container{
  /* width: 16.58rem; */
  height: 9.42rem;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: start;
  padding-top: 2.14rem;
  padding-bottom: 2.14rem;
  border-bottom: 1px #dfdddd solid;
  cursor: pointer;
}
.UN-info-img{
  width: 8.6rem;
  height: 5.07rem;
}
.UN-other-txt-container{
  width: 30.5rem;
  height: 5.07rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin-left: 0.71rem;
}
</style>
